/**
 * NewsItemView view component.
 * @module components/theme/View/NewsItemView
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Container, Image } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';
import { FormattedDate } from '@plone/volto/components';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';

/**
 * NewsItemView view component class.
 * @function NewsItemView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const NewsItemView = ({ content }) => {
  return (
    <Container className="view-wrapper newspage">
      {content.title && <h2>{content.title}</h2>}

      {content.image && (
        <p className="block image align left">
          <Image
            className="documentImage newsimage"
            alt={content.title}
            title={content.title}
            src={flattenToAppURL(content.image.download)}
          />
        </p>
      )}
      <div className="news_text">
        <RenderBlocks
          content={content}
          location={content.id}
          className="news_text"
        />
      </div>
      {content.review_state === 'published' && content.effective && (
        <p>
          <FormattedDate date={content.effective} />
        </p>
      )}
    </Container>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
NewsItemView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    text: PropTypes.shape({
      data: PropTypes.string,
    }),
  }).isRequired,
};

export default NewsItemView;
